import { combineReducers } from 'redux';
import canvas from './canvas';

const rootReducer = combineReducers({
  canvas,
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/